import { Maximize2, Minimize2 } from "lucide-react";
import { Button } from "../Button";

export function FocusExpandButton({
    expanded,
    onToggle,
    label,
    className = "",
}: {
    expanded: boolean;
    onToggle: () => void;
    label: string;
    className?: string;
}) {
    const accessibleLabel = expanded ? "Restore split view" : `Expand ${label}`;

    return (
        <Button
            variant="ghost"
            size="sm"
            className={`focus-expand-toggle${className ? ` ${className}` : ""}`}
            data-expanded={expanded}
            onClick={onToggle}
            aria-label={accessibleLabel}
            title={accessibleLabel}
        >
            <span className="focus-expand-icon" aria-hidden="true">
                <Maximize2 className="focus-expand-grow" />
                <Minimize2 className="focus-expand-shrink" />
            </span>
        </Button>
    );
}
